<div class="stepper">
  <div
    #stepRef
    (click)="goToStep(i)"
    *ngFor="let step of steps; let i = index"
    [class.active]="i === currentStep"
    [class.completed]="i < currentStep"
    class="step"
  >
    <span class="step__icon">
      <ng-container *ngIf="i < currentStep; else stepNumber">
        <span class="step__check">✔</span>
      </ng-container>
      <ng-template #stepNumber>{{ i + 1 }}</ng-template>
    </span>
    <span class="step__label">{{ step.label }}</span>
  </div>
</div>
<div class="scroll-container"
     style="margin-bottom: 88px">
  <div *ngIf="currentStep === 0">
    <div class="bank-card">
      <div class="bank-card__header">
      <span class="bank-card__icon">
        <svg fill="none"
             viewBox="0 0 40 40"
             xmlns="http://www.w3.org/2000/svg">
          <circle cx="20"
                  cy="20"
                  fill="#3a8dde"
                  r="18"/>
          <path
            d="M12 22V18C12 17.4477 12.4477 17 13 17H27C27.5523 17 28 17.4477 28 18V22"
            stroke="#fff"
            stroke-linecap="round"
            stroke-width="2.2"
          />
          <rect fill="#fff"
                height="4"
                rx="1.5"
                width="11"
                x="14.5"
                y="22.5"/>
          <circle cx="17.5"
                  cy="24.5"
                  fill="#3a8dde"
                  r="0.9"/>
          <circle cx="22.5"
                  cy="24.5"
                  fill="#3a8dde"
                  r="0.9"/>
        </svg>
      </span>
        <span class="bank-card__bank-name">{{ bankName }}</span>
      </div>
      <div class="bank-card__number">
        {{ cardNumber | spaceString:4 }}
        <img (click)="copyToClipboard(cardNumber)"
             src="/icons/copy.svg">
      </div>
      <div class="bank-card__footer">
        <span class="bank-card__holder">{{ cardHolder }}</span>
        <span class="bank-card__amount">{{ amount | number }} ریال</span>
      </div>
    </div>
    <div class="financial-box">
      <div class="financial-content">
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ 'Sum' | translate }}</span>
          <p>{{ StringUtil.numberAsCurrency(factor?.Price ?? 0) + 'ریال' }}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ 'ValueAddedTax' | translate }}</span>
          <p>{{ StringUtil.numberAsCurrency(factor?.TaxPrice ?? 0) + 'ریال' }}</p>
        </div>
        <div class="d-flex align-items-center justify-content-between">
          <span>{{ 'ShippingCost' | translate }}</span>
          <p>{{ StringUtil.numberAsCurrency(factor?.DeliveryPrice ?? 0) + 'ریال' }}</p>
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between payable">
        <span>{{ 'Payable' | translate }}</span>
        <p>{{ StringUtil.numberAsCurrency(factor?.PayablePrice ?? 0) + 'ریال' }}</p>
      </div>
    </div>
  </div>
  <div *ngIf="currentStep === 1"
       class="step2-form">
    <app-frontend-input
      [(value)]="payAmount"
      [required]="true"
      [title]="'مبلغ پرداختی (ریال)'"
      style="background: #DEDEDE;border-radius: 10px"
    ></app-frontend-input>
    <app-frontend-input
      [(value)]="trackingNumber"
      [title]="'شماره پیگیری پرداخت'"
      style="background: #DEDEDE;border-radius: 10px"
    ></app-frontend-input>
    <div class="step2-desc">
      شماره پیگیری معمولاً یک عدد ۵ رقمی است که پس از پرداخت در رسید بانکی نمایش
      داده می‌شود.
    </div>
    <app-frontend-file-chooser
      [(files)]="cardImageFiles"
      [accept]="'image/*'"
      [isMultiple]="false"
      [required]="true"
      [title]="'رسید کارت به کارت خود را بارگذاری کنید'"
      class="step2-upload"
    ></app-frontend-file-chooser>
  </div>
  <div *ngIf="currentStep === 2"
       class="step3-confirm">
    <div class="step3-icon">🎉</div>
    <div class="step3-title">دریافت شد!</div>
    <div class="step3-desc">
      سفارش شما در حال بررسی می‌باشد. نتیجه از طریق پیامک اطلاع‌رسانی خواهد شد.
    </div>
  </div>
  <div class="step-actions">
    @if (currentStep !== 0) {
      <button (click)="goToStep((currentStep-1))"
              class="prev-btn">{{ 'بازگشت' | translate }}
      </button>
    } @else {
      <button (click)="goToOrders()"
              class="prev-btn">{{ 'بازگشت به صفحه ی سفارشات' | translate }}
      </button>
    }
    @if (currentStep === 0) {
      <button
        (click)="goToStep(currentStep+1)"
        class="next-btn">
        {{ ('بعدی' | translate) }}
      </button>
    } @else if (currentStep === 1) {
      <button
        (click)="submitInformation()"
        class="next-btn">{{ 'ارسال اطلاعات' | translate }}
      </button>
    } @else if (currentStep === 2) {
      <button
        (click)="goToOrders()"
        class="next-btn">
        {{ 'بازگشت به صفحه ی سفارشات'  | translate }}
      </button>
    }
  </div>
</div>
